export default "__VITE_ASSET__Ccs86CVX__"